/**
 * Classe utilitaire qui sert à stocker le libelle pour faire de la comparaison
 *
 */
const typeLibelleService = {
  typeCategorieDepense: "DEPENSE",
  typeCategorieRecette: "RECETTE",
  typeDeviseEuro: "EUR",
  typeCategorieDon: "DON",
};

export function isCategorieDepense(libelle) {
  return (
    typeof libelle === "string" &&
    libelle.toUpperCase() === typeLibelleService.typeCategorieDepense
  );
}

export function isCategorieRecette(libelle) {
  return (
    typeof libelle === "string" &&
    libelle.toUpperCase() === typeLibelleService.typeCategorieRecette
  );
}

export function isDeviseEuro(libelle) {
  return (
    typeof libelle === "string" &&
    libelle.toUpperCase() === typeLibelleService.typeDeviseEuro
  );
}

export function isCategorieDon(libelle) {
  return (
    typeof libelle === "string" &&
    libelle.toUpperCase() === typeLibelleService.typeCategorieDon
  );
}

export default typeLibelleService;
